export default "__VITE_ASSET__atUOzTzI__"